import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=d1b9b2c6"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplate.vue?vue&type=style&index=0&id=d1b9b2c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports